import SVGA from 'svgaplayerweb';
import EXIF from 'exif-js';

let utils = {};

/** 将时间戳转为日期格式 */
utils.formatDateWithStamp = function(stamp, isFull = false, fmt = '-'){
  const oDate = new Date(stamp);
  const year = oDate.getFullYear();
  const month = oDate.getMonth() + 1;
  const date = oDate.getDate();
  let result = '';

  if(isFull){
    result = `${year}${fmt}${utils.zeroPad(month)}${fmt}${utils.zeroPad(date)}`;
  }else{
    result = `${utils.zeroPad(month)}${fmt}${utils.zeroPad(date)}`;
  }

  return result;
};

/** 对象深拷贝 */
utils.deepCopy = function(data) {
  let type = utils.type(data),
      result,
      i,
      len;

  if (type === 'array') {
    result = [];

    for (i = 0, len = data.length; i < len; i++) {
      result.push(this.deepCopy(data[i]));
    }
    return result;
  } else if (type === 'object') {
    result = {};

    for (i in data) {
      result[i] = this.deepCopy(data[i]);
    }
    return result;
  }else{
    return data;
  }
};

/** 获取今天和明天年月日 */
utils.getTodayAndTomorrow = function(){
  let currentDate = new Date();
  let currentTimestamp = currentDate.getTime();
  let currentYear = currentDate.getFullYear();
  let currentMonth = currentDate.getMonth() + 1;
  let currentDay = currentDate.getDate();
  let currentWeekIndex = currentDate.getDay();

  let nextTimestamp = currentTimestamp + (24 * 60 * 60 * 1000);
  let nextDate = new Date(nextTimestamp);
  let nextYear = nextDate.getFullYear();
  let nextMonth = nextDate.getMonth() + 1;
  let nextDay = nextDate.getDate();
  let nextWeekIndex = nextDate.getDay();

  return {
    today: [currentYear, this.zeroPad(currentMonth), this.zeroPad(currentDay), currentWeekIndex],
    tomorrow: [nextYear, this.zeroPad(nextMonth), this.zeroPad(nextDay), nextWeekIndex],
  };
};

/** 获取今后天和大后天年月日 */
utils.getAfterTomorrow = function(){
  let afterTomorrow = new Date();
  let threeDays = new Date();

  afterTomorrow.setDate(afterTomorrow.getDate() + 2); // 后天
  threeDays.setDate(threeDays.getDate() + 3);         // 大后天

  let currentYear = afterTomorrow.getFullYear();
  let currentMonth = afterTomorrow.getMonth() + 1;
  let currentDay = afterTomorrow.getDate();
  let currentWeekIndex = afterTomorrow.getDay();

  let nextYear = threeDays.getFullYear();
  let nextMonth = threeDays.getMonth() + 1;
  let nextDay = threeDays.getDate();
  let nextWeekIndex = threeDays.getDay();

  return {
    today: [currentYear, this.zeroPad(currentMonth), this.zeroPad(currentDay), currentWeekIndex],
    tomorrow: [nextYear, this.zeroPad(nextMonth), this.zeroPad(nextDay), nextWeekIndex],
  };
};

/** 计算两个日期间的天数 */
utils.calcCycle = function(startDate, endDate){
  // console.log(startDate, '/', endDate);
  const oToday = new Date(startDate);
  const oTarget = new Date(endDate);
  const startTimestamp = +(new Date(oToday.getFullYear(), oToday.getMonth(), oToday.getDate()).getTime());
  const endTimestamp = +(new Date(oTarget.getFullYear(), oTarget.getMonth(), oTarget.getDate()).getTime());
  const isTomorrow = (endTimestamp - startTimestamp) / 1000 / 3600 / 24;

  return isTomorrow;
};

/** 检测日期是否为当天日期 */
utils.checkDateIsToday = function(date){
  let oDate = new Date(date);
  let oCurDate = new Date();

  if(oDate.getFullYear() == oCurDate.getFullYear() && oDate.getMonth() == oCurDate.getMonth() && oDate.getDate() == oCurDate.getDate()){
    return 'today';
  }else if(utils.calcCycle(oCurDate, date) === 1){
    return 'tomorrow';
  }
};

/** 组合起始日期数组 */
utils.combineDateFromArr = function(startArr, endArr, fmt = '-'){
  const start = `${startArr[0]}${fmt}${startArr[1]}${fmt}${startArr[2]}`;
  const end = `${endArr[0]}${fmt}${endArr[1]}${fmt}${endArr[2]}`;

  return {start, end};
};

/** 小于10的数字补0 */
utils.zeroPad = function(number){
  return Number(number) < 10 ? '0' + Number(number) : Number(number);
};

/** 类型检查 */
utils.type = function(obj) {
  const toString = Object.prototype.toString;
  const map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  };

  return map[toString.call(obj)];
};

/** 语言类型区分 */
utils.getLangType = function(lanType){
  let type = 1;

  switch (lanType) {
    case 'zh_cn': type = 1; break;
    case 'ja_jp': type = 2; break;
    case 'zh_hk': type = 3; break;
    case 'en_us': type = 4; break;
    case 'ko_kr': type = 5; break;
    default: type = 1;
  }

  return type;
};

/** 从URL获取语言类型和货币 */
utils.getLanTypeFromUrl = function(){
  const q = window.location.href.split('?')[1];

  if(q){
    const splitWithAnd = q.split('&');

    splitWithAnd.forEach(item => {
      const it = item.split('=');

      if(it[0] === 'lan_type'){
        window.localStorage.setItem(it[0], this.getLangType(it[1]));
      }else{
        window.localStorage.setItem(it[0], it[1]);
      }

      if(it[0] === 'currency_code'){
        const currency = (it[1] && it[1] !== 'null' && it[1] !== 'undefined') ? it[1] : 'CNY';

        window.localStorage.setItem('currency_code', currency);
      }else{
        window.localStorage.setItem('currency_code', 'CNY');
      }
    });
  }else{
    window.localStorage.setItem('lan_type', 1);
    window.localStorage.setItem('currency_code', 'CNY');
  }
};

/** 保存语言类型和币种到本地 */
utils.saveLangAndCurrency = function(q){
  if(q.lan_type){
    const currency = (q.currency_code && q.currency_code !== 'null' && q.currency_code !== 'undefined') ? q.currency_code : 'CNY';

    localStorage.setItem('lan_type', this.getLangType(q.lan_type));
    localStorage.setItem('lan_name', q.lan_type);
    localStorage.setItem('currency_code', currency);
  }
};

/** 设置html和body的样式 */
utils.setBodyStyle = function (styleOpts = {}) {
  const oHtml = document.documentElement;
  const oBody = document.body || document.querySelector('body');

  for(let k in styleOpts){
    oHtml.style[k] = styleOpts[k];
    oBody.style[k] = styleOpts[k];
  }
};

/** 微信支付 */
utils.wxPayment = function (consume) {
  return new Promise(resolve => {
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
        "appId": consume.appId,         // 公众号名称，由商户传入
        "timeStamp": consume.timeStamp, // 时间戳，自1970年以来的秒数
        "nonceStr": consume.nonceStr,   // 随机串
        "package": consume.package,
        "signType": 'MD5',              // 微信签名方式：
        "paySign": consume.paySign       // 微信签名
      },
      function(res){
        if(res.err_msg == "get_brand_wcpay_request:ok" ){
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          resolve(true);
        }
        resolve(false);
      });
  });
};

/** 其他第三方支付：支付宝、银联等 */
utils.otherPayment = function (consume) {
  let oBody = document.querySelector('body');
  let oForm = document.createElement('form');

  oForm.setAttribute('method', 'POST');
  oForm.setAttribute('action', consume.action);
  for(let k in consume.params){
    let oInput = document.createElement('input');

    oInput.setAttribute('type', 'hidden');
    oInput.setAttribute('name', k);
    oInput.setAttribute('value', consume.params[k]);
    oForm.appendChild(oInput);
  }

  oBody.appendChild(oForm);
  oForm.submit();
  oBody.removeChild(oForm);
};

/** 判断是否在微信中打开 */
utils.isWechatBrowser = function () {
  let ua = navigator.userAgent.toLowerCase();

  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  }

  return false;
};

/** 从本地读取货币和语言类型 */
utils.getLangAndCurrencyFromLocal = function(){
  let currency = 'CNY';
  let langType = 1;

  if(localStorage.getItem('currency_code') != 'undefined'){
    currency = localStorage.getItem('currency_code');
  }

  if(localStorage.getItem('lan_type') != 'undefined'){
    langType = localStorage.getItem('lan_type');
  }

  return {currency_code: currency, lan_type: langType};
};

/** 处理SVGA动画 */
utils.transformSVGA = function(playerIdSelector, sourceUrl){
  var player = new SVGA.Player(playerIdSelector);
  var parser = new SVGA.Parser(playerIdSelector);

  parser.load(sourceUrl, function(videoItem) {
    player.setVideoItem(videoItem);
    player.startAnimation();
  });

  return player;
};

/**
 * 生成随机字符串
 * @param min：最小长度
 * @param max：最大长度
 * @param randomFlag：是否生成在最小和最大长度之间的字符串
 * @returns {string}
 */
utils.randomString = function(min = 16, max = 128, randomFlag){
  let str = '', range = min;
  const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  // 随机产生
  if(randomFlag){
    range = Math.round(Math.random() * (max - min)) + min;
  }

  for(let i = 0; i < range; i++){
    const pos = Math.round(Math.random() * (arr.length - 1));

    str += arr[pos];
  }

  return str;
};

/**
 *
 * @param file
 * @param config
 * config = {accuracy[压缩精度], size[指定压缩的目标大小], success[压缩成功回调函数，返回值为base64地址]}
 */
utils.imageCompressAndRotate = function (file, config) {
  const reader = new FileReader(),
      image = new Image();
    // type = null;

  const name = file.name;

  // type = (name.substr(name.lastIndexOf("."))).toLowerCase();
  // if (type !== '.jpg' && type !== '.png' && type !== '.jpeg' && type !== '.gif') {
  //   return false;
  // }

  const fileSize = file.size;

  // 精度小于0.8或大于0.99默认设置为0.95
  if (!config.accuracy || config.accuracy < 0.8 || config.accuracy > 0.99) {
    config.accuracy = 0.95;     // 默认精度0.95
  }

  // 结合文件大小和压缩精度计算目标文件的大小范围
  const resultSize = {
    max: config.size * (2 - config.accuracy) * 1024,
    accurate: config.size * 1024,
    min: config.size * config.accuracy * 1024,
  };

  /**
   * 经过测试发现，blob.size与dataURL.length的比值约等于0.75
   * 这个比值可以同过dataURLtoFile这个方法来测试验证
   * 这里为了提高性能，直接通过这个比值来计算出blob.size
   */
  let proportion = 0.75;      // blob.size与dataURL.length的比值
  let imageQuality = 0.5;     // 压缩图片到起始质量系数

  if (file) {
    let Orientation = null;

    EXIF.getData(file, function() {
      Orientation = EXIF.getTag(this, 'Orientation');
    });

    reader.readAsDataURL(file);
    reader.onload = function (ev) {
      image.src = ev.target.result;
      image.onload = function () {
        let imgWidth = this.width,
            imgHeight = this.height;

        const canvas = document.createElement("canvas"),
              ctx = canvas.getContext('2d');

        canvas.width = imgWidth;
        canvas.height = imgHeight;
        if (Orientation && Orientation != 1) {
          switch(Orientation) {
            case 6:     // 旋转90度
              canvas.width = imgHeight;
              canvas.height = imgWidth;
              ctx.rotate(Math.PI / 2);
              // (0, -imgHeight) 从旋转原理图那里获得的起始点
              ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
              break;
            case 3:     // 旋转180度
              ctx.rotate(Math.PI);
              ctx.drawImage(this, -imgWidth, -imgHeight, imgWidth, imgHeight);
              break;
            case 8:     // 旋转-90度
              canvas.width = imgHeight;
              canvas.height = imgWidth;
              ctx.rotate(3 * Math.PI / 2);
              ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
              break;
          }
        } else {
          ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
        }

        // 图片压缩后的结果
        let compressDataURL;
        // 临时存储到压缩结果，用来做最优压缩结果处理
        const tempDataURLs = [null, null];

        // 如果指定文件大小大于原文件大小，则不做压缩处理
        if (config.size * 1024 > fileSize) {
          compressDataURL = canvas.toDataURL('image/jpeg', 1);
        }else{
          for (let x = 1; x <= 7; x++) {
            compressDataURL = canvas.toDataURL('image/jpeg', imageQuality);

            // 当前图片尺寸
            let CalculationSize = compressDataURL.length * proportion;

            // 如果到循环第七次还没有达到精确度的值，那说明该图片不能达到到此精确度要求
            // 这时候最后一次循环出来的dataURL可能不是最精确的，需要取其周边两个dataURL三者比较来选出最精确的；
            if (x === 7) {
              if (resultSize.max < CalculationSize || resultSize.min > CalculationSize) {
                compressDataURL = [compressDataURL, tempDataURLs[0], tempDataURLs[1]]
                  .filter(function (i) {
                    return i;
                  }).sort(function (a, b) {
                    return Math.abs(a.length * proportion - resultSize.accurate) - Math.abs(b.length * proportion - resultSize.accurate);
                  })[0];
              }
              break;
            }

            if (resultSize.max < CalculationSize) {
              tempDataURLs[1] = compressDataURL;
              imageQuality -= 0.5 ** (x + 1);
            } else if (resultSize.min > CalculationSize) {
              tempDataURLs[0] = compressDataURL;
              imageQuality += 0.5 ** (x + 1);
            } else {
              break;
            }
          }
        }

        config.success && config.success(compressDataURL);
      }
    }
  }
};

/** 获取系统名称 */
utils.getSystem = function(){
  const u = window.navigator.userAgent;
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  let sysName = '';

  if (isAndroid) {
    sysName = 'Android';
  }
  if (isIOS) {
    sysName = 'IOS';
  }

  return sysName;
};

/** 生成随机字符串 */
utils.randomString = function(oLen){
  const len = oLen || 32;
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  const maxPos = chars.length;
  let pwd = '';

  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return pwd;
};

/** 获取文件后缀名 */
utils.getSuffix = function(filename) {
  const pos = filename.lastIndexOf('.');
  let suffix = '';

  if (pos !== -1) {
    suffix = filename.substring(pos);
  }

  return suffix;
};

export default utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js